import { render } from "./ScoreboardWhoCanView.vue?vue&type=template&id=7787cea6&ts=true"
import script from "./ScoreboardWhoCanView.vue?vue&type=script&lang=ts"
export * from "./ScoreboardWhoCanView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__